import { createSelector } from 'reselect';

import { initialState } from './reducers';

const selectState = (state) => state.get('volunteersPage') || initialState;

export const selectFetchParams = createSelector(selectState, (state) => state.get('fetchParams'));

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectInitialized = createSelector(selectState, (state) => state.get('initialized'));

export const selectVerifying = createSelector(selectState, (state) => state.get('verifying'));

export const selectSort = createSelector(selectState, (state) => state.get('sort'));

export const selectOrder = createSelector(selectState, (state) => state.get('order'));

export const selectSearch = createSelector(selectState, (state) => state.get('search'));

export const selectSendingEmail = createSelector(selectState, (state) =>
  state.get('sendingPacUploadEmailNotification ')
);
